'use client'

import dynamic from 'next/dynamic'
import { useEffect } from 'react'

// Lazy-loaded so its CSS/JS chunk isn't preloaded on every page — only when the error boundary renders
const ServerError = dynamic(() => import('@/screens/ServerError').then(m => m.ServerError))

type Props = {
	error: Error & { digest?: string }
	reset: () => void
}

export default function ErrorPage({ error: _error, reset: _reset }: Props) {
	useEffect(() => {
		document.title = 'iPort – 500 (ошибка сервера)'
	}, [])

	return (
		<>
			<ServerError title="500. Ошибка сервера" />
		</>
	)
}
